/**
 * Die kurze Kennung eines Modellbauteils aus seiner Revit-UniqueId.
 *
 * --- Warum die ersten acht Zeichen nichts taugen ---------------------------
 *
 * Eine UniqueId sieht so aus:
 *
 *     56b73fd9-7977-40ab-aef0-8d70c6710658-003069af
 *     └────────────── Dokument ──────────────┘ └Element┘
 *
 * Der vordere Teil gehört dem MODELL, nicht dem Bauteil. Alle Auslässe eines
 * Modells tragen ihn gleich. Eine Befundliste, die `slice(0, 8)` zeigt,
 * schreibt in jede Zeile dasselbe — acht verschiedene Auslässe sahen aus wie
 * acht Mal derselbe. Genau so ist es dem Fachplaner am 18.09.2026 aufgefallen.
 *
 * Unterscheidbar ist der Elementanteil hinter dem letzten Bindestrich.
 */
export function elementkennung(uniqueId: string): string {
  const teile = uniqueId.split('-');

  // Eine UniqueId hat sechs Teile: fünf der Dokument-GUID, einer das Element.
  // Alles andere ist keine UniqueId — dann lieber den ganzen Text zeigen als
  // einen willkürlichen Ausschnitt.
  if (teile.length < 6) return uniqueId;

  const element = teile[teile.length - 1];

  // Führende Nullen weg: '003069af' ist dieselbe Zahl wie '3069af', und die
  // kurze Form lässt sich mit der Elementnummer in Revit vergleichen.
  const kurz = element.replace(/^0+/, '');

  return kurz.length > 0 ? kurz : element;
}
